export class HtmlUtil {
  static parseHtml(content: string) {
    return content.replace(/<[^>]*>/g, '');
  }
}
